'use client';

import { c as _c } from "react/compiler-runtime";
import FullscreenButton from '@/app/[locale]/(worlds)/[roomId]/components/FullscreenButton';
import GithubButton from '@/app/[locale]/(worlds)/[roomId]/components/GithubButton';
import LikeButton from '@/app/[locale]/(worlds)/[roomId]/components/LikeButton';
import SaveButton from '@/app/[locale]/(worlds)/[roomId]/components/SaveButton';
import SharePopoverButton from '@/app/[locale]/(worlds)/[roomId]/components/SharePopoverButton';
import WorldMoreActionButton from '@/app/[locale]/(worlds)/[roomId]/components/WorldMoreActionButton';
import WorldReportModal from '@/app/[locale]/(worlds)/[roomId]/components/WorldReportModal';
import ReportConfirmationModal from '@/components/ReportConfirmationModal';
import { BTN_GLASS_PILL } from '@/constants/action-buttons';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { useIsClient } from 'usehooks-ts';
export default function WorldActionButtons(t0) {
  const $ = _c(28);
  const {
    className
  } = t0;
  const {
    isMobile
  } = useUAContext();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const isClient = useIsClient();
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isReportSuccessOpen, setIsReportSuccessOpen] = useState(false);
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex shrink-0 flex-col items-end gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LikeButton className={BTN_GLASS_PILL} iconClassName="[&>path]:fill-vive-primary-20 size-5 shrink-0" labelClassName="text-vive-primary-20 text-[14px] leading-[18px] font-semibold tracking-[0.15px]" size="custom" showCount={true} />;
    t3 = <SaveButton className={BTN_GLASS_PILL} iconClassName="size-4.5" />;
    t4 = <SharePopoverButton className={BTN_GLASS_PILL} iconClassName="size-5" size="custom" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isClient || $[6] !== isMobile) {
    t5 = isClient && !isMobile && <GithubButton className={BTN_GLASS_PILL} iconClassName="size-5" />;
    $[5] = isClient;
    $[6] = isMobile;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isClient || $[9] !== isMobile || $[10] !== roomData) {
    t6 = isClient && !isMobile && roomData.scene_type === "standalone" && <FullscreenButton className={BTN_GLASS_PILL} iconClassName="size-5" />;
    $[8] = isClient;
    $[9] = isMobile;
    $[10] = roomData;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <WorldMoreActionButton className={BTN_GLASS_PILL} handleReport={() => setIsReportModalOpen(true)} iconClassName="size-5" size="custom" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsReportModalOpen(false);
    t9 = () => setIsReportSuccessOpen(true);
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isReportModalOpen) {
    t10 = <WorldReportModal isDialogOpen={isReportModalOpen} onClose={t8} onReportSuccess={t9} />;
    $[15] = isReportModalOpen;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsReportSuccessOpen(false);
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== isReportSuccessOpen) {
    t12 = <ReportConfirmationModal open={isReportSuccessOpen} onAction={t11} />;
    $[18] = isReportSuccessOpen;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12 || $[22] !== t5 || $[23] !== t6) {
    t13 = <div className="flex gap-2">{t2}{t3}{t4}{t5}{t6}{t7}{t10}{t12}</div>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t5;
    $[23] = t6;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t1 || $[26] !== t13) {
    t14 = <div className={t1}>{t13}</div>;
    $[25] = t1;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
}